<template>
  <div class="rule">
    <div class="rule_nav">
      <navbar
        title="协议内容"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
    </div>
    <van-row class="box" v-html="aggrement"> </van-row>
    <van-row class="rule_footer">
      <van-col span="24">
        <btn
          :btntext="'阅读并同意'"
          :btnwidth="'35.1rem'"
          :height="'4.4rem'"
          :bgcolor="'#FF5F2E'"
          :borderradius="'2.5rem'"
          :btncolor="'#fff'"
          :fontsize="'1.7rem'"
          @btnClick="goodsDetail"
        />
      </van-col>
    </van-row>
  </div>
</template>
<script>
import navbar from "../accountAgent/components/nav-bar.vue";
import btn from "../accountAgent/components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      aggrement: "",
    };
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    this.getInfo();
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getInfo() {
      this.$api.get("cms-v2/member/agreement/detail", {
          number: this.$route.query.agreementId,
      }).then((res) => {
          this.aggrement = res.content;
      });
    },
    goodsDetail() {
      this.params(
        this.$route.query.goodsId,
        this.$route.query.goodsId,
        "goodsDetail"
      );
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.rule {
  height: 100%;
  box-sizing: border-box;
  background: #e3e3e3;

  .rule_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #fff;
    z-index: 3;
  }

  .box {
    padding: 10rem 1.2rem 9.8rem;
    box-sizing: border-box;
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    background: #fff;
    font-size: 1.3rem;
    line-height: 2rem;
    img {
      width: 100% !important;
      display: block;
      height: auto !important;
    }
  }

  .rule_footer {
    position: fixed;
    bottom: 3.4rem;
    left: 0;
    width: 100%;
    padding-left: 1.2rem;
  }
}
</style>


